import React, {useState, useEffect} from 'react';
import {Query} from 'react-apollo';
// import AddBtn from '../addBtn/addBtn';
import CreateGroup from './createGroup';
import UpdateGroup from './updateGroup';
import css from './groupsList.scss';
import {GET_GROUPS} from './queries';
import {Redirect} from 'react-router';

function GroupsList(props) {
		const authToken = localStorage.getItem('token');
		const [originalData, setOriginalData] = useState([]);
		const [groups, setGroups] = useState([]);
		const [sort, setSort] = useState(false);
		const [triangleTitle, setTriangleTitle] = useState('Trier par ordre croissant (de A à Z)');
		const sortGroups = target => {
			if (sort === false) {
				setSort('asc');
				setGroups([...originalData].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())));
				setTriangleTitle('Trier par ordre décroissant (de Z à A)');
			} else if (sort === 'asc') {
				setSort('desc');
				setGroups([...originalData].sort((a, b) => b.name.toLowerCase().localeCompare(a.name.toLowerCase())));
				setTriangleTitle('Trier par ordre croissant (de A à Z)');
				Object.assign(target.style, {
					transform: "rotate(180deg)",
					transition: "ease-in-out .2s"
				});
			} else {
				setSort('asc');
				setGroups([...originalData].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())));
				setTriangleTitle('Trier par ordre décroissant (de Z à A)');
				Object.assign(target.style, {
					transform: "rotate(360deg)",
					transition: "ease-in-out .2s"
				});
			}
		}

		useEffect(() => {
			setGroups(originalData);
		}, [originalData])

		useEffect(() => {
			setGroups([...originalData].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())));
		}, [originalData])

		if (!authToken) {
			return <Redirect to="/" />;
		}
		return (
			<ul key="groupsList" className={css.list}>
				<img alt="" title={triangleTitle} onClick={e => sortGroups(e.target)} className={css.triangle} src="/triangle.png" />
				<Query query={GET_GROUPS}>
					{({loading, error, data}) => {
						if (loading) {
							return <div className={css.error}>Loading</div>;
						}
						if (error) {
							return (
								<div className={css.error}>
									Une erreur est survenue :{' '}
									<strong>
										{error.graphQLErrors[0]}
									</strong>
								</div>
							);
						}
						setOriginalData(data.groups);
						return null;
					}}
				</Query>
				<CreateGroup
					key="create"
					addGroup={props.addGroup}
				/>
				{groups.map((data, i) => (
					<UpdateGroup key={data.id} {...data} />
				))}
			</ul>
			// <AddBtn key="btn">Ajouter un groupe</AddBtn>,
		);
}

export default GroupsList;



// WEBPACK FOOTER //
// ./src/groupsList/groupsList.js